<script lang="ts">
  export let ordersFromCustomerService: boolean;
  export let distributorId: number;
  export let useCustomerService: (event: any) => void;

</script>

<label class="fizz-flex-row-8">
  <input
    type="checkbox"
    class="fizz-checkbox fizz-inline-8"
    id="customer-service-{distributorId}"
    bind:checked={ordersFromCustomerService}
    on:change={useCustomerService}
  />
  I order from customer service, not a sales rep
</label>
